// Function to convert base64 to Blob
const base64ToBlob = (base64Data, contentType = '') => {
    // Remove any prefix, e.g., "data:image/png;base64,"
    const base64String = base64Data.split(',').pop();
    const byteCharacters = atob(base64String); // Decode base64
    const byteNumbers = new Array(byteCharacters.length)
      .fill(0)
      .map((_, i) => byteCharacters.charCodeAt(i));
    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], { type: contentType });
  };
  
  // Function to convert base64 to File
  export const  base64ToFile = async (base64Data, fileName, contentType = 'image/png') => {    
    const blob = base64ToBlob(base64Data, contentType);
    return new File([blob], fileName, { type: contentType });
  };